export default __webpack_public_path__ + "static/media/transfer.54887f0e.svg";